export default "dist/images/components-columns-width-control-3-2.d0cd0a1.png";